import { html } from 'lit-html';

const template = (data) => html`
<div class="info-window-project" data-is-open="${data.state.isInfowindowOpen}">
	${data.state.selectedProject ? html`
		${(data => {
		if(data.state.selectedProject.getFeaturedImageSrc()) {
			return html`<div class="info-window-project-image">
				<img src="${data.state.selectedProject.getFeaturedImageSrc()}" >
			</div>
			`;
		}
	})(data)}
		<div class="info-window-project-content">
			<h3 class="info-window-project-name">${data.state.selectedProject.getName()}</h3>
			<div class="info-window-project-excerpt">
				<p>
					${data.state.selectedProject.getDescription({ trim: true })}
				</p>
			</div>
			<div class="info-window-project-footer-container">
				<a class="button" href="${data.state.selectedProject.getUrl()}">Bekijk project</a>
			</div>
		</div>
		<div class="info-window-project-close"></div>
		` : ''}
</div>
`;

export default template;